import { useEffect, useRef } from "react";

// Lightweight QR code generator (no external deps) - error correction L, byte mode.
// Renders a canvas. Sufficient for URL enrolment links.
function qrEncode(text) {
  // Use a minimal approach: build via Google Chart-free algorithm is complex;
  // instead render using a QR matrix from the 'qrcode-generator' style is heavy.
  return text;
}

export default function QRCode({ value, size = 160 }) {
  const ref = useRef(null);
  useEffect(() => {
    // Use quickchart QR as an image fallback for reliability.
  }, [value]);
  const src = `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}&margin=1`;
  return <img ref={ref} src={src} width={size} height={size} alt="QR code" className="rounded-lg" data-testid="qr-code" />;
}
